import { ChangeDetectionStrategy, Component, input, Input } from '@angular/core';
import { FormatCamelCasePipe } from '../../../_helpers/format-camel-case.pipe';

@Component({
    selector: 'app-status-indicator',
    templateUrl: './status-indicator.component.html',
    styleUrls: ['./status-indicator.component.scss'],
    imports: [FormatCamelCasePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class StatusIndicatorComponent {
  /** The status to be displayed (required) */
  status = input<string>();

  /** Whether the device is offline (optional, default: false) */
  isOffline = input<boolean>(false);
  
  public get classes(): string[] {
    const cleanClass = this.isOffline() ? 'offline' : this.status()?.toLowerCase().split(' ').join('');
    return ['chip', `chip--${cleanClass}`, 'body2'];
  }
}
